// extracted by mini-css-extract-plugin
module.exports = {"root":"SelectPayment_root__1zuY0","text":"SelectPayment_text__3p_V0","title":"SelectPayment_title__iRKSQ","btn":"SelectPayment_btn__aRJD4"};